// 引入 vue
import Vue from 'vue'
// 引入分页插件
import infiniteScroll from 'vue-infinite-scroll'
// 注册插件
Vue.use(infiniteScroll)



// WEBPACK FOOTER //
// ./src/lib/vueInfiniteScroll/index.js